var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-not-found-block component"},[_c('div',{staticClass:"ui-not-found-block__content"},[_c('UiBaseIcon',{attrs:{"width":"36px","height":"36px","iconName":"error"}}),_c('h3',[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }